import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  async copyLink() {
    try {
      const shareUrl = window.location.origin + this.urlValue
      await navigator.clipboard.writeText(shareUrl)
      
      // Show a toast notification using the standard toast system
      this.showToast("Share link copied to clipboard!", "success")
    } catch (err) {
      console.error('Failed to copy: ', err)
      this.showToast("Failed to copy share link", "error")
    }
  }

  showToast(message, type) {
    // Use the standard toast system by creating toast elements directly
    // This matches the structure from shared/_toast.html.erb
    const flashContainer = document.getElementById('flash_messages')
    if (flashContainer) {
      // Determine alert class and icon based on type
      let alertClass, icon
      switch (type) {
        case 'error':
          alertClass = 'alert-error'
          icon = 'ph:x-circle'
          break
        case 'warning':
          alertClass = 'alert-warning'
          icon = 'ph:warning'
          break
        default: // success or default
          alertClass = 'alert-success'
          icon = 'ph:check-circle'
          break
      }

      // Create the toast element matching the shared/toast partial structure
      const toastElement = document.createElement('div')
      toastElement.className = 'toast-container fixed bottom-4 right-4 z-50'
      toastElement.setAttribute('data-controller', 'flash')
      toastElement.setAttribute('data-action', 'animationend->flash#remove')
      
      toastElement.innerHTML = `
        <div class="alert ${alertClass} shadow-lg">
          <div class="flex items-center gap-2">
            <iconify-icon icon="${icon}" class="text-xl"></iconify-icon>
            <span>${message}</span>
          </div>
        </div>
      `
      
      // Append to flash messages container
      flashContainer.appendChild(toastElement)
    }
  }
} 